import { useContext } from 'react';
import { ScheduledMeetingsContext } from '../ScheduledMeetingsProvider';
import type { ScheduledMeetingsContextValue } from '../types';

/**
 * Hook to access scheduled meetings context
 *
 * @throws Error if used outside ScheduledMeetingsProvider
 *
 * @example
 * ```tsx
 * const { meetings, createMeeting, isLoading } = useScheduledMeetings();
 * ```
 */
const useScheduledMeetings = (): ScheduledMeetingsContextValue => {
  const context = useContext(ScheduledMeetingsContext);

  if (!context) {
    throw new Error('useScheduledMeetings must be used within a ScheduledMeetingsProvider');
  }

  return context;
};

export default useScheduledMeetings;
